import { useAbility } from '@cast/shared-ability-data-access';

/**
 * Feature flag to skip all assignments fetching and related functionality
 * for organizations where the non-paginated assignments endpoint causes the commitments page to fail.
 */
export const useAllAssignmentsFetchingDisabled = (): boolean => {
  return useAbility().can(
    'view',
    'FeatureCommitmentsDisableAllAssignmentsFetching'
  );
};
